import { cn as e } from "../../shared/utils.js";
import { useTranslation as t } from "../../i18n/hooks.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/date-picker/primitive/date-range-summary.tsx
function i({ className: i, fromValue: a, toValue: o }) {
	let { t: s } = t();
	return /* @__PURE__ */ r("div", {
		className: e("text-text-secondary tablet:text-lg flex flex-wrap gap-2 text-base font-normal", i),
		children: [/* @__PURE__ */ r("div", {
			className: "flex items-center gap-1",
			children: [/* @__PURE__ */ r("span", {
				className: "text-text-secondary",
				children: [s("public_pages_purchase.date_picker.from"), ":"]
			}), /* @__PURE__ */ n("span", {
				className: "text-text-primary tablet:font-normal font-medium",
				children: a
			})]
		}), /* @__PURE__ */ r("div", {
			className: "flex items-center gap-1",
			children: [/* @__PURE__ */ r("span", {
				className: "text-text-secondary",
				children: [s("public_pages_purchase.date_picker.to"), ":"]
			}), /* @__PURE__ */ n("span", {
				className: "text-text-primary tablet:font-normal font-medium",
				children: o
			})]
		})]
	});
}
//#endregion
export { i as DateRangeSummary };
